import { useEffect, useLayoutEffect, useState } from 'react';

/** SideBar를 오버레이 드로어로 쓸 뷰포트 (데스크톱 레일은 `lg` 이상) */
const MOBILE_NAV_MEDIA_QUERY = '(max-width: 1023px)';

export function useMobileNavLayout(): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(MOBILE_NAV_MEDIA_QUERY).matches : false
  );

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_NAV_MEDIA_QUERY);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}

/** 모바일이면 드로어 닫기, 데스크톱이면 레일 펼치기 등 뷰포트 전환 시 동기화 */
export function useSyncSidebarLayoutWithViewport(setSidebarOpen: (open: boolean) => void): void {
  useLayoutEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.matchMedia(MOBILE_NAV_MEDIA_QUERY).matches) {
      setSidebarOpen(false);
    }
  }, [setSidebarOpen]);

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_NAV_MEDIA_QUERY);
    const onChange = (e: MediaQueryListEvent) => {
      if (e.matches) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [setSidebarOpen]);
}
